<template>
  <div class="footer">
    <div class="footerContent">
      <div class="footer__column">
        <router-link class="column__heading" :to="{ name: isLoggedIn ? 'companies' : 'auth' }">Wowzi</router-link>
        <span class="column__text address">4th Floor, Gateway Place, Milimani Road, Nairobi</span>
        <span class="column__text address"><a href="tel:+254729998980">+254729998980</a></span>
        <span class="column__text">
          <a href="https://mail.google.com/mail/?view=cm&fs=1&to=support@wowzi.co" target="_blank">support@wowzi.co</a>
        </span>
      </div>
      <div class="footer__column">
        <router-link class="column__text" to="/faq">FAQ</router-link>
        <router-link class="column__text" to="/terms-and-conditions">Terms and Conditions</router-link>
        <router-link class="column__text" to="/privacypolicy">Privacy policy</router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import { useAuthStore } from '@/store/auth';
  import { mapState } from 'pinia';

  export default {
    name: 'FooterComponent',
    computed: {
      ...mapState(useAuthStore, ['isLoggedIn']),
    },
  };
</script>

<style lang="scss">
  @import '~/bulma/sass/utilities/mixins';
  @import '@/assets/styles/variables';

  .footer {
    height: 144px;
    width: 100%;
    background-color: $secondary-dark;
    color: $white;
    display: flex;
    padding: 0 420px;
    justify-content: space-between;

    @include desktop-only {
      padding: 0 300px;
    }

    @include touch {
      flex-direction: column;
      height: auto;
      padding: 16px;
    }
    .footerContent {
      display: flex;
      width: 850px;
      justify-content: space-between;
      margin: 0 auto;
      @media (max-width: 1440px) {
        width: 100%;
        margin: 0 auto;
      }
      @media (max-width: 767px) {
        width: 100%;
        margin: 0 auto;
        flex-direction: column;
      }
    }
    .footer__column {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-end;
      padding: 24px 0 24px 0;

      @include touch {
        padding: 0 0 16px;
      }
    }

    .column__heading {
      color: $white;
      cursor: pointer;
      font-weight: bold;
      padding: 0;
      font-size: 14px;
      line-height: 18px;
    }

    .column__text {
      color: $white;
      cursor: pointer;
      padding-top: 8px;
      font-size: 14px;
      line-height: 18px;
      a {
        color: white;
      }
    }
    .address {
      cursor: default;
    }
  }
</style>
